import React from "react";
import { Spinner } from "../../state-indicators";

import "./wait-dialog.scss";

const WaitDialog = () => {
    return (
        <div id="wait-popup-window" className="popup-window popup-window_opened wait-popup-window">
            <div style={{ position: "relative", height: "100%", width: "100%" }}>
                <Spinner withCaption />
            </div>
        </div>
    );
};

export default WaitDialog;
